import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TooltipProvider } from "./components/ui/tooltip";
import { getLang, setLang, useI18n } from "./i18n";
import { onUnauthorized } from "./lib/api";
import { createQueryClient, qk } from "./lib/query";
import { applyTheme, watchSystemTheme } from "./lib/theme";
import { createAppRouter } from "./router";
import "@tenanci/docs/prose.css";
import "./styles.css";

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

applyTheme();
watchSystemTheme();
setLang(getLang());

// Sessão expirou no meio do uso: limpa o cache e volta para o login.
onUnauthorized(() => {
  queryClient.setQueryData(qk.session, null);
  const { pathname, href } = router.state.location;
  if (!["/login", "/signup", "/auth/callback"].includes(pathname)) {
    void router.navigate({ to: "/login", search: { redirect: href } });
  }
});

// Modo mock (VITE_MOCK_API=1, só em dev): API fake no navegador via MSW.
if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API) {
  const { startMockApi } = await import("./mocks/browser");
  await startMockApi();
}

/** Trocar o idioma remonta as telas: os textos lidos na renderização (strings.ts das funções) seguem o novo idioma. */
function App() {
  const { lang } = useI18n();
  return <RouterProvider key={lang} router={router} />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <App />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
